// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
'use strict';

var $dot$dot = require("..");

function isTabtest(att) {
  return $dot$dot.getAttachmentFilename(att) === "patch.test.tsv";
}

function getFilename(prim) {
  return $dot$dot.getAttachmentFilename(prim);
}

function getContent(prim) {
  return $dot$dot.getAttachmentContent(prim);
}

function getEncoding(prim) {
  return $dot$dot.getAttachmentEncoding(prim);
}

exports.getFilename = getFilename;
exports.getContent = getContent;
exports.getEncoding = getEncoding;
exports.isTabtest = isTabtest;
/* .. Not a pure module */



// WEBPACK FOOTER //
// ../src/Attachment.bs.js